import { palette } from '@centivo/react-components'
import styled from 'styled-components'

export const ViewContainer = styled.main`
  font-size: 1rem;
  margin: auto;
  max-width: 77.5rem;
  width: 98%;
  padding: 2rem;

  .template--privacy-policy {
    ol,
    ul {
      margin-left: 3em;
    }

    ul {
      list-style: disc;
    }

    ol ul {
      list-style: circle;
    }

    h2 {
      font-size: 2em;
      margin-top: 1em;
      font-weight: 600;
      color: ${palette.brand.purple};
    }

    h3 {
      font-size: 1.5em;
      margin-top: 1em;
      font-weight: 600;
      font-style: italic;
      color: ${palette.brand.pink};
    }

    p {
      font-size: 1em;

      a {
        margin-left: 0.25em;
      }
    }

    p + p {
      margin-top: 1em;
    }
  }
`
